import Vue from 'vue'

import {VueMaskDirective} from 'v-mask'

Vue.directive('mask', VueMaskDirective);
//import PhoneMaskInput from "vue-phone-mask-input";

import {TheMask} from "vue-the-mask";
import {parsePhoneNumberFromString} from "libphonenumber-js";
import CountryFlag from "vue-country-flag";

import {
  getMaskToLibPhoneNumber,
  findFirstCountryByAlpha2,
  findFirstCountryByCode,
  isCanada
} from "~/helpers/countryPhoneData.js";
